import { render, staticRenderFns } from "./WcFormsTranslations.vue?vue&type=template&id=33dbf82a&lang=pug&"
import script from "./WcFormsTranslations.vue?vue&type=script&lang=js&"
export * from "./WcFormsTranslations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports